var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 65,
    viewBox: "0 0 94 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54659 61.6292C3.82093 61.6292 3.33688 60.8805 3.63466 60.2188L28.5009 4.96046C28.6624 4.60161 29.0193 4.37082 29.4128 4.37082H38.5906C38.9837 4.37082 39.3403 4.60111 39.502 4.95937L64.4472 60.2177C64.746 60.8796 64.262 61.6292 63.5358 61.6292H54.6188C54.219 61.6292 53.8577 61.3911 53.6999 61.0238L32.3917 11.4095C32.1083 10.7495 32.5923 10.0149 33.3106 10.0149H34.5307C35.2483 10.0149 35.7323 10.7484 35.45 11.4082L14.2204 61.0226C14.063 61.3905 13.7013 61.6292 13.3011 61.6292H4.54659ZM16.261 48.3779C15.5748 48.3779 15.0924 47.7025 15.3152 47.0534L17.4918 40.71C17.6305 40.306 18.0105 40.0346 18.4377 40.0346H47.929C48.3562 40.0346 48.7362 40.306 48.8748 40.71L51.0515 47.0534C51.2742 47.7025 50.7919 48.3779 50.1056 48.3779H16.261Z",
    fill: "url(#paint0_linear_498_6696)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3663 61.6292C72.814 61.6292 72.3663 61.1814 72.3663 60.6292V5.37082C72.3663 4.81853 72.814 4.37082 73.3663 4.37082H82C82.5523 4.37082 83 4.81853 83 5.37082V60.6292C83 61.1814 82.5523 61.6292 82 61.6292H73.3663Z",
    fill: "url(#paint1_linear_498_6696)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5009 3.96046L25.9538 3.71424L1.08751 58.9726C0.611056 60.0314 1.38554 61.2292 2.54659 61.2292H11.3011C11.9415 61.2292 12.5202 60.8473 12.7721 60.2586L18.0269 47.9779H45.8735L51.1486 60.2606C51.401 60.8483 51.9792 61.2292 52.6188 61.2292H61.5358C62.6977 61.2292 63.4721 60.0298 62.9941 58.9708L38.0489 3.7125C37.7901 3.13928 37.2195 2.77082 36.5906 2.77082H27.4128C26.7832 2.77082 26.2121 3.14008 25.9538 3.71424L26.5009 3.96046ZM31.9245 15.4988L41.7749 38.4346H22.1104L31.9245 15.4988ZM69.7663 59.6292C69.7663 60.5128 70.4827 61.2292 71.3663 61.2292H80C80.8837 61.2292 81.6 60.5128 81.6 59.6292V4.37082C81.6 3.48716 80.8837 2.77082 80 2.77082H71.3663C70.4827 2.77082 69.7663 3.48716 69.7663 4.37082V59.6292Z",
    stroke: "url(#paint2_linear_498_6696)",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.3968 24.8295L84.0262 29.6383L88.8349 32.2676L84.0262 34.897L81.3968 39.7057L78.7675 34.897L73.9587 32.2676L78.7675 29.6383L81.3968 24.8295Z",
    fill: "#EF3C76"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_498_6696",
    x1: 43,
    y1: 4.37082,
    x2: 43,
    y2: 66.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_498_6696",
    x1: 43,
    y1: 4.37082,
    x2: 43,
    y2: 66.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_498_6696",
    x1: 41,
    y1: 3.37082,
    x2: 41,
    y2: 60.6292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.40a30977ad5a68715a6242b6f1defa50.svg";
export { ForwardRef as ReactComponent };